// components/PrivateRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { makeStyles, tokens, Spinner } from '@fluentui/react-components';
import { useAuth } from '../context/AuthContext';
import { isContentRole } from '../utils/roles';

const useStyles = makeStyles({
  loading: {
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground3,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const PrivateRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const s = useStyles();

  if (isLoading) {
    return (
      <div className={s.loading}>
        <Spinner size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // adminOnly admits 'editor' too — the /admin/* shell itself is shared by both;
  // individual content-only pages allow editors, the rest stay backend-gated to
  // admin/sysadmin (see requireContentRole vs requireAdmin on the API side).
  if (adminOnly && !isContentRole(user)) {
    return <Navigate to="/user" replace />;
  }

  return children;
};

export default PrivateRoute;
